import { useState } from 'react';

import { Plan } from '@/component';
import { TENANT_CONST } from '@/constant';
import { VFlex, VStack } from '@/package';
import type { Tenant } from '@/type';

type ChangePlanModalProps = {
  tenant: Tenant;

  onBillingUnitChange?(billingUnit: Tenant['billingUnit']): void;
  onTierClick?(tier: Tenant['tier']): void;
};

export const ChangePlanModalContent = ({
  tenant,
  onBillingUnitChange,
  onTierClick,
}: ChangePlanModalProps) => {
  const [tier, setTier] = useState(tenant.tier);

  return (
    <VStack aria-label="change-plan-modal-main" gap={1}>
      <VFlex gap={1} justify="center">
        {Object.values(TENANT_CONST.TIER)
          .slice(1)
          .map(t => {
            return (
              <Plan.Item
                key={t}
                initBillingUnit={
                  t === TENANT_CONST.TIER.FREETIER ? 1 : tenant.billingUnit
                }
                isSelected={tier === t}
                tier={t}
                onBillingUnitChange={onBillingUnitChange}
                onTierClick={() => {
                  setTier(t);
                  onTierClick?.(t);
                }}
              />
            );
          })}
      </VFlex>
    </VStack>
  );
};

ChangePlanModalContent.displayName = 'ChangePlanModalContent';
